// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"topAward_root__KWnYw","title":"topAward_title__60KIn","contentIcon":"topAward_contentIcon__9R12N"};